import React, { useState } from "react";

import PropertyCard from "../registryForms/PropertyCard";
import PropertyCardHeader from "../registryForms/PropertyCardHeader";
import AddPropertyPopup from "../AddingForms/AddPropertyPopup";
import { uniqueIdBuilder } from "../../util/Dynamics";
import AddDATPropertyPopup from "../AddingForms/AddDATPropertyPopup";


function CustomerPropertyFormBox(props) {
    const {multiple = true} = props;

    const [show, setShow] = useState(false);

    const addProperty = () => {
        setShow(true);
    }

    const close = () => {
        setShow(false);
    }

    const onRemove = (id) => {
        const index = props.cards.findIndex(itm => {
            return itm.id === id;
        });

        props.update({
            id: "immobili",
            removing: true,
            data: index
        });

    }

    const renderPopup = () => {
        switch(props?.service){
            case "DAT":
                return <AddDATPropertyPopup close={close} update={props.update} />

            default:
                return <AddPropertyPopup  year={props.year} close={close} update={props.update} />
        }
    }

    return (
        <>
            <section className="it-page-section" id={props.id}>
                <div className="cmp-card mb-40">
                    {show && renderPopup()}
                    <div className="card has-bkg-grey shadow-sm p-big">
                        <PropertyCardHeader />

                        <div className="card-body p-0">
                            {
                                props.cards.map((card, idx) => {
                                    return <PropertyCard
                                        year={props.year}
                                        info={card}
                                        service={props?.service}
                                        update={props.update}
                                        remove={onRemove}
                                        key={uniqueIdBuilder()} />
                                })
                            }

                            {/* adder button */}
                            {(multiple || (!multiple && props?.cards?.length === 0)) &&  
                            <button
                                type="button"
                                className="btn plus-text mt-20 p-0"
                                onClick={addProperty}>
                                <span className="rounded-icon">
                                    <svg className="icon icon-primary icon-sm" aria-hidden="true">
                                        <use href="../assets/bootstrap-italia/dist/svg/sprites.svg#it-plus-circle" />
                                    </svg>
                                </span>
                                <span>Aggiungi Immobile</span>
                            </button>}
                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}


export default CustomerPropertyFormBox;